/**
 * Web build entry point. ES module import order guarantees the preload
 * replacement (window.api) is fully installed before the renderer entry
 * module evaluates — it logs through window.api at module scope.
 *
 * Persisted File System Access mounts are restored — and small persisted
 * caches preloaded into the fs sync snapshot — before the renderer loads:
 * the renderer's startup game discovery re-validates discovered paths
 * (removeDisappearedGames) and reads the game-image cache synchronously, so
 * both must be ready by then. webpackMode "eager" keeps everything in the
 * single output bundle — the dynamic import only defers evaluation.
 */
import "./preload-web";
import { prewarmCaches, restoreMounts } from "./fsa-mounts";
Promise.all([
    restoreMounts().catch((err) => console.warn("[vortex-web] FSA mount restore failed", err)),
    prewarmCaches().catch((err) => console.warn("[vortex-web] cache prewarm failed", err)),
]).then(() => import(/* webpackMode: "eager" */ "@/renderer"));
